<template>
    <div class="w-100" v-if="items.length" :class="{ 'mobile-container': width < 600 }">
        <div class="event-card-body">
            <div class="artist-card-info">
                <div class="artist-count">
                    {{ itemsCount }} Artist{{ itemsCount > 1 ? 's' : '' }} Booked
                    <div class="artist-payout">
                        ${{ getTotalBookedBudget }} in Total
                        {{ items.length > 1 ? 'Payouts' : 'Payout' }}
                    </div>
                </div>
            </div>
            <div class="event-status-pills">
                <button v-if="eventStatus === 1" @click="goToAdvance" class="book-artists">
                    Finalize Lineup
                </button>
                <button v-if="eventStatus === 2" @click="goToBook" class="book-artists">
                    Book More Artists
                </button>
            </div>
        </div>
        <div class="artists-page">
            <div
                v-for="(item, index) in items"
                :key="index"
                @click="goToArtist(item.slug)"
                class="artist-book-card-flow"
                role="button"
            >
                <div class="user-sample-card">
                    <div class="user-photo-top">
                        <img :src="item.profile_picture" alt="" class="user-img-top" />
                    </div>
                </div>
                <div class="artist-card-body-flow">
                    <div class="artist-band-name-flow">
                        <div class="artist-name-flow">
                            <a :href="'/artists/' + item.slug" target="_blank">{{
                                item.artist_name
                            }}</a>
                        </div>
                        <div class="social-stats-flow">
                            <div class="star-num">{{ item.rating }}</div>
                            <img :src="getIcon + 'Star1.png'" alt="" class="social-img" />
                        </div>
                    </div>
                    <div class="social-reach-card-flow">
                        <span>{{ formatSummedValue(item.social_reach) }}</span>
                        <span> Social Reach</span>
                    </div>
                    <div class="atrist-locat-flow">{{ item.location }}</div>
                    <div class="border-lineup-flow"></div>
                    <div class="per-set-price-flow">
                        <span>
                            {{ '$' + venuePays(item) }}/ {{ item.propose.duration_minutes }}min
                            Set</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-line-up-flow"></div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { notification } from '../../../../helpers/notification'
    import checkScreen from '../../../../mixins/check-screen'

    export default {
        name: 'ArtistBooked',
        mixins: [checkScreen],
        props: {
            eventId: {
                type: Number
            },
            venueId: {
                type: Number
            },
            eventStatus: {
                type: Number
            }
        },
        data: () => ({
            items: [],
            minPrice: 0,
            maxPrice: 0,
            openInvite: false
        }),
        computed: {
            getTotalBookedBudget() {
                let totalPayout = 0
                this.items.forEach((item) => {
                    totalPayout += parseInt(this.venuePays(item))
                })
                return totalPayout
            },
            itemsCount() {
                return this.items.length
            },
            getIcon() {
                return '/images/'
            },
            venuePays() {
                return (artist) => {
                    // const venuePays = parseFloat(artist.propose.booked_payout)
                    const venuePays = parseFloat(artist.propose.payout)
                    return venuePays.toFixed(0)
                }
            }
        },
        methods: {
            goToArtist(slug) {
                if (!slug) return
                window.open('/artists/' + slug, '_blank')
            },
            formatSummedValue(num) {
                if (num >= 1_000_000_000) {
                    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
                }
                if (num >= 1_000_000) {
                    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
                }
                if (num >= 1_000) {
                    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
                }
                return num.toFixed(0).toString()
            },
            async getArtistBookedCard() {
                try {
                    const response = await axios.get(
                        '/api/events/manage/' + this.eventId + '/artists-booked-cards'
                    )
                    this.items = response.data.data
                } catch (error) {
                    notification('error', error)
                }
            },
            async getOffersTOtoReview() {
                try {
                    const response = await axios.get(
                        '/api/events/manage/' + this.eventId + '/offers-to-review-info'
                    )
                    this.minPrice = response.data.data.allocated_budget_min
                    this.maxPrice = response.data.data.allocated_budget_max
                } catch (error) {
                    notification('error', error)
                }
            },
            async goToAdvance() {
                try {
                    await axios.put('/api/event/' + this.eventId + '/finalize')
                    window.location.href = `/event/advance-book-artist/${this.eventId}/${this.venueId}`
                } catch (error) {
                    notification('error', error)
                }
            },
            async goToBook() {
                try {
                    await axios.put('/api/event/' + this.eventId + '/back-to-book')
                    window.location.href = '/event/book-artist'
                } catch (error) {
                    notification('error', error)
                }
            }
        },
        async created() {
            await this.getArtistBookedCard()
            await this.getOffersTOtoReview()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    a {
        color: #acacac;
        text-decoration: none;
    }
    .mobile-container {
        display: flex;
        flex-direction: column;
        gap: 32px;
    }
    .bottom-line-up-flow {
        display: flex;
        flex-direction: row;
        border: 1px solid #646464;
        width: 90%;
        margin: 25px 60px 60px 60px;
    }
    .artist-card-body-flow {
        display: flex;
        flex-direction: column;
        padding: 12px 15px 11px 15px;
        width: 100%;
    }
    .user-photo-top {
        height: 100%;
    }
    .user-img-top {
        border-radius: 15px 0 0 15px;
        max-width: 126px;
        height: 100%;
        object-fit: cover;
    }
    .per-set-price-flow {
        color: #8b8b8b;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
    }
    .border-lineup-flow {
        border: 1px solid #646464;
        margin: 10px 10px 7px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .atrist-locat-flow {
        color: #646464;
        font-size: 12px;
        font-family: 'Instrument Sans';
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        max-width: 290px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .social-reach-card-flow {
        color: #acacac;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .social-img {
        max-height: 18px;
        max-width: 18px;
    }
    .star-num {
        color: #acacac;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.16px;
        padding: 0 5px;
    }
    .social-stats-flow {
        display: flex;
        align-items: center;
        margin-right: 15px;
    }
    .artist-name-flow {
        color: #acacac;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 20px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        text-decoration: none;
    }
    .artist-band-name-flow {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        color: #acacac;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 20px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 120%;
    }
    .artist-book-card-flow {
        display: flex;
        flex-direction: row;
        border-radius: 15px;
        border: 1px solid #000;
        background: #262626;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        margin: 10px 10px;
        flex: 0 0 40%;
    }
    .artists-page {
        display: flex;
        margin: 50px;
        flex-wrap: wrap;
    }
    .artists-page::-webkit-scrollbar {
        display: none;
    }
    .book-artists {
        color: #262626;
        text-align: left;
        font: 600 18px/120% 'Montserrat', sans-serif;
        position: relative;
        border: none;
        background: none;
    }
    .event-status-pills,
    .event-status-pills * {
        box-sizing: border-box;
    }
    .event-status-pills {
        background: #c9cd00;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        padding: 7px 30px 10px 30px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        min-width: 220px;
        min-height: 45px;
        position: relative;
        margin: 0 60px;
    }
    .artist-count {
        color: #c9cd00;
        font-size: 44px;
        font-family: 'Instrument Sans';
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        display: flex;
        align-items: center;
    }

    .artist-payout {
        color: #8b8b8b;
        margin-left: 25px;
        font-size: 20px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        margin-top: 10px;
    }
    .event-card-body {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }
    .artist-card-info {
        display: flex;
        flex-direction: row;
        margin: 0 60px;
        align-items: center;
    }

    @media (max-width: 600px) {
        .artist-count {
            flex-wrap: wrap;
        }
        .event-card-body {
            gap: 32px;
            flex-wrap: wrap;
        }
        .artist-card-info {
            margin: 0 16px;
        }
        .artist-payout {
            margin-left: 0;
            font-size: 18px;
        }
        .event-status-pills {
            margin: 0 16px;
            width: 100%;
        }
        .artist-count {
            font-size: 38px;
        }
        .artist-book-card-flow {
            flex: 0 0 100%;
            margin: 0;
        }
        .artists-page {
            margin: 0 16px;
            gap: 16px;
        }
        .user-img-top {
            min-width: 124px !important;
            min-height: 124px !important;
            object-fit: cover;
        }
        .bottom-line-up-flow {
            margin: 40px 16px;
        }
    }
</style>
